import { injectCodeMirror } from './codemirror';
import { registerComponents } from './global';
import { injectServices } from './services';

export const init = () => {
	injectServices();
	registerComponents();
	injectCodeMirror();
};
